// Types
import type { TTabPosition } from './Tabs.type';

// Constants
import { TABS_POSITION } from './Tab.constant';

export const getTabsIndicator = (tabsPosition: TTabPosition, tabRef: HTMLDivElement | null) => {
	switch (tabsPosition) {
		case TABS_POSITION.right: {
			return {
				top: tabRef?.offsetTop,
			}
		}
		case TABS_POSITION.bottom: {
			return {
				left: tabRef?.offsetLeft,
				width: tabRef?.offsetWidth,
			}
		}
		case TABS_POSITION.left: {
			return {
				top: tabRef?.offsetTop,
			}
		}
		default: {
			return {
				left: tabRef?.offsetLeft,
				width: tabRef?.offsetWidth,
			}
		}
	}
}
